import { ArrowRight } from "lucide-react";
import { PLAN_ICONS } from "../../plans/data/icons";
import { Campaign } from "../types";

interface CampaignCardProps {
  campaign: Campaign;
  onOpen: (campaign: Campaign) => void;
}

export function CampaignCard({ campaign, onOpen }: CampaignCardProps) {
  const TagIcon = PLAN_ICONS[campaign.tagIcon];
  const Fallback = PLAN_ICONS[campaign.icon];

  return (
    <button
      type="button"
      onClick={() => onOpen(campaign)}
      className="group flex w-full items-center gap-3 rounded-card border border-commerce/20 bg-commerce-soft p-3.5 text-left transition hover:border-commerce/50 hover:bg-commerce/[0.14] sm:gap-4 sm:p-5"
    >
      <span className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-commerce/20 bg-surface sm:h-16 sm:w-16 sm:rounded-2xl">
        {campaign.emblem ? (
          <img src={campaign.emblem} alt="" className="h-full w-full object-contain p-1.5" />
        ) : (
          <Fallback aria-hidden className="h-6 w-6 text-commerce-ink sm:h-8 sm:w-8" strokeWidth={1.75} />
        )}
      </span>

      <span className="min-w-0 flex-1">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-commerce px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-commerce-contrast">
          <TagIcon className="h-3.5 w-3.5" strokeWidth={2.25} />
          {campaign.tag}
        </span>
        <span className="mt-2 block text-base font-bold leading-tight text-ink sm:text-lg">{campaign.title}</span>
        <span className="mt-1 block text-[13px] leading-5 text-ink-secondary sm:text-sm">{campaign.description}</span>
      </span>

      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-surface text-commerce-ink shadow-panel transition group-hover:translate-x-0.5 group-hover:bg-commerce group-hover:text-commerce-contrast sm:h-10 sm:w-10">
        <ArrowRight className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>
    </button>
  );
}
